import union from 'lodash/union';
import {
	type Operand,
	OPERAND_TYPE_KEYWORD,
	OPERAND_TYPE_LIST,
	OPERAND_TYPE_VALUE,
} from '@atlaskit/jql-ast';

export const getOperandValues = (operand: Operand): string[] => {
	switch (operand?.operandType) {
		case OPERAND_TYPE_KEYWORD:
		case OPERAND_TYPE_VALUE: {
			return [operand.value];
		}
		case OPERAND_TYPE_LIST: {
			return union(...operand.values.map((operandValue) => getOperandValues(operandValue)));
		}
		default: {
			return [];
		}
	}
};
